import React from "react";

const NoTask = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M30.526 23.189v9.224c0 .42-.166.825-.461 1.122a1.566 1.566 0 01-1.113.465H3.575a1.572 1.572 0 01-1.118-.477A1.603 1.603 0 012 32.39V13.2h9.509c.42 0 .823-.169 1.12-.469.298-.3.465-.707.465-1.131V2h15.85c.874 0 1.582.728 1.582 1.587v6.024l-14.261 14.4-.01 6.781 6.73.01 7.541-7.613zm1.233-10.296L34 15.155 21.674 27.6l-2.244-.003.003-2.26 12.326-12.444zM2 10l7.924-7.995V10H2z"
            fill={fill}
        />
    </svg>
);

export default NoTask;